import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched } from 'formik';
import { useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ReleaseElectoralCard } from 'front-office/view-models/release-electoral-card';
import { noop } from 'shell/utils/noop';
import AccordionPersonForm from 'shell/components/shared/person/form';
import { AccordionPersonForm as AccordionPersonFormVM } from 'shell/view-models/accordion-person-form';

interface AccordionPerson {
  fiscalCode?: string;
  name?: string;
  surname?: string;
  personState?: string;
  values?: ReleaseElectoralCard;
  onChange: (
    key: keyof ReleaseElectoralCard,
    value: ReleaseElectoralCard[keyof ReleaseElectoralCard]
  ) => void;
  errors?: FormikErrors<ReleaseElectoralCard>;
  touched?: FormikTouched<ReleaseElectoralCard>;
  isForPersonDetailPage?: boolean;
}

const AccordionPerson = ({
  values,
  fiscalCode,
  name,
  surname,
  personState,
  isForPersonDetailPage,
}: AccordionPerson): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const valuesCalculated = useMemo(() => {
    return {
      ...values,
      fiscalCode: values?.fiscalCode || fiscalCode,
      name: values?.name || name,
      surname: values?.surname || surname,
      state: values?.personForm?.state || personState,
    };
  }, [values, name, surname, personState]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-persons-card"
        id="panel-persons-card"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>{'Persona'}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionPersonForm
          family={values?.family}
          citizenship={values?.citizenship}
          onChange={noop}
          values={valuesCalculated?.personForm as AccordionPersonFormVM}
          isForPersonDetailPage={isForPersonDetailPage}
          disabled
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionPerson.displayName = 'Persons electoral card data';

export default AccordionPerson;
